import pluralize from 'pluralize';
import * as React from 'react';
import { FormattedNumber } from 'react-intl';

import Text from 'components/Text';

type Props = {
  label: string;
  value: number;
};

export default function NumberWithLabel(props: Props) {
  const { label, value, ...others } = props;

  return (
    <Text {...others}>
      <FormattedNumber value={value} /> {pluralize(label, value)}
    </Text>
  );
}
